import { render, staticRenderFns } from "./PortalFaqs.vue?vue&type=template&id=3f1f747c&"
import script from "./PortalFaqs.vue?vue&type=script&lang=js&"
export * from "./PortalFaqs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports